/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_NotesInputs */



/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Event_Group_Sync_Property_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_notes = /** @type {((inputs?: Event_Group_Sync_Property_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Notes")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notes")
	return /** @type {LocalizedString} */ ("Notes")
});